(function () {
  let isLoading = false;
  let lastLoadKey = '';

  function getConfig() {
    const el = document.getElementById('CollectionParentFilterConfig');
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch {
      return null;
    }
  }

  function getLoadKey(config) {
    return `${config.pages}-${config.productsCount}-${config.pageSize}-${window.location.search}`;
  }

  function getSearchParams() {
    const params = new URLSearchParams(window.location.search);
    params.delete('page');
    const str = params.toString();
    return str ? `&${str}` : '';
  }

  function extractProductId(item) {
    const link = item.querySelector('[id^="CardLink-"]');
    if (!link) return null;
    const parts = link.id.split('-');
    return parts[parts.length - 1] || null;
  }

  function getProductItems(doc) {
    const grid = doc.getElementById('product-grid');
    if (!grid) return [];
    return [...grid.querySelectorAll('li.grid__item')].filter((item) => item.querySelector('.product-card-wrapper'));
  }

  function getExistingIds(grid) {
    return new Set(
      [...grid.querySelectorAll('li.grid__item')]
        .map(extractProductId)
        .filter(Boolean)
    );
  }

  function removeEmptyPlaceholder(grid) {
    grid.querySelectorAll('li.grid__item').forEach((item) => {
      if (!item.querySelector('.product-card-wrapper')) {
        item.remove();
      }
    });
  }

  function hidePagination(container) {
    container.querySelectorAll('.pagination-wrapper').forEach((pagination) => pagination.remove());
  }

  function setLoadingState(container, isActive) {
    const status = container.querySelector('#CollectionParentFilterStatus');
    if (status) status.classList.toggle('hidden', !isActive);
  }

  function prepareGridItem(item, animationOrder) {
    const clone = item.cloneNode(true);
    clone.querySelectorAll('.scroll-trigger').forEach((element) => {
      element.classList.add('scroll-trigger--cancel');
      element.classList.remove('scroll-trigger--offscreen');
    });
    const cascade = clone.querySelector('[data-cascade]');
    if (cascade) cascade.style.setProperty('--animation-order', String(animationOrder));
    return clone;
  }

  function getTotalPages(config) {
    const fromPaginate = Number(config.pages) || 1;
    const productsCount = Number(config.productsCount) || 0;
    const pageSize = Number(config.pageSize) || 250;
    const computedAtPageSize = pageSize > 0 ? Math.ceil(productsCount / pageSize) : 1;
    return Math.max(fromPaginate, computedAtPageSize);
  }

  async function fetchPageItems(path, sectionId, page, baseParams) {
    const url = `${path}?section_id=${sectionId}&page=${page}${baseParams}`;
    const response = await fetch(url);
    const html = await response.text();
    return getProductItems(new DOMParser().parseFromString(html, 'text/html'));
  }

  function appendItems(grid, items, existingIds) {
    let animationOrder = grid.querySelectorAll('li.grid__item .product-card-wrapper').length;
    let addedCount = 0;

    items.forEach((item) => {
      const id = extractProductId(item);
      if (!id || existingIds.has(id)) return;
      existingIds.add(id);
      animationOrder += 1;
      grid.appendChild(prepareGridItem(item, animationOrder));
      addedCount += 1;
    });

    return addedCount;
  }

  async function loadAllParentProductPages() {
    const config = getConfig();
    if (!config?.enabled || isLoading) return;

    const loadKey = getLoadKey(config);
    const totalPages = getTotalPages(config);
    if (totalPages <= 1) return;

    const grid = document.getElementById('product-grid');
    const container = document.getElementById('ProductGridContainer');
    if (!grid || !container) return;

    if (grid.dataset.parentFilterComplete === loadKey) return;

    isLoading = true;
    setLoadingState(container, true);

    try {
      const existingIds = getExistingIds(grid);
      const baseParams = getSearchParams();
      const sectionId = config.sectionId;
      const path = window.location.pathname;

      for (let page = 2; page <= totalPages; page += 1) {
        const items = await fetchPageItems(path, sectionId, page, baseParams);
        if (items.length === 0) break;
        appendItems(grid, items, existingIds);
      }

      removeEmptyPlaceholder(grid);
      hidePagination(container);
      grid.dataset.parentFilterComplete = loadKey;
      lastLoadKey = loadKey;

      if (typeof initializeScrollAnimationTrigger === 'function') {
        initializeScrollAnimationTrigger(grid);
      }
    } catch (error) {
      console.error('Failed to load parent collection products', error);
    } finally {
      setLoadingState(container, false);
      isLoading = false;
    }
  }

  function init() {
    loadAllParentProductPages();

    const container = document.getElementById('ProductGridContainer');
    if (!container) return;

    const observer = new MutationObserver(() => {
      if (isLoading) return;

      const config = getConfig();
      if (!config?.enabled) return;

      const loadKey = getLoadKey(config);
      if (loadKey === lastLoadKey) return;

      const grid = document.getElementById('product-grid');
      if (grid) delete grid.dataset.parentFilterComplete;
      loadAllParentProductPages();
    });

    observer.observe(container, { childList: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
